import {Module} from 'vuex';
import {User, Role} from '@/entities';
import {State} from '@/store';
import {authUserService} from '@/services/user';
import {roleService} from '@/services';
import BaseError from '@/error';


export class CouldNotFetchUserRoleError extends BaseError {
  readonly name = "CouldNotFetchUserRoleError";
  constructor(roleId: number, cause: Error | null = null) {
    super(`Role of id ${roleId} could not be fetched.`, cause)
  }
}
export interface ModuleState {
  user: User | null;
  role: Role | null;
  isAuthenticated: boolean;
  hasBeenValidated: boolean;
}
export const authUserModule: Module<ModuleState, State> = {
  namespaced: true,
  state: {
    user: null,
    role: null,
    isAuthenticated: false,
    hasBeenValidated: false,
  },
  getters: {

  },
  mutations: {
    setUser(state, user: User) {
      state.user = user;
    },
    setRole(state, role: Role) {
      state.role = role;
    },
    setIsAuthenticated(state, isAuthenticated: boolean) {
      state.isAuthenticated = isAuthenticated;
    },
    setHasBeenValidated(state, hasBeenValidated: boolean) {
      state.hasBeenValidated = hasBeenValidated;
    },
    setUnauthenticated(state) {
      state.user = null;
      state.role = null;
      state.isAuthenticated = false;
    }
  },
  actions: {
    async getAuthUser(ctx) {
      try {
        const user = await authUserService.getUser();
        const role = await roleService.getRole(user.roleId);
        if (!role) {
          ctx.commit('setUnauthenticated');
          throw new CouldNotFetchUserRoleError(user.roleId)
        }
        ctx.commit('setUser', user);
        ctx.commit('setRole', role);
        ctx.commit('setIsAuthenticated', true);
        ctx.commit('setHasBeenValidated', true);
      } catch (e) {
        ctx.commit('setUnauthenticated');
        ctx.commit('setHasBeenValidated', false);
        return;
      }
    },
    async logout(ctx) {
      try {
        await authUserService.logout();
      } finally {
        ctx.commit('setUnauthenticated');
        ctx.commit('setHasBeenValidated', false);
      }

    }
  },
};
